import { FormControl } from 'parkdepot-shared/components/FormControl'
import Input, { InputProps } from 'parkdepot-shared/components/Input/Input'
import React, { FC } from 'react'
import { FormControlOverrides } from './EmailInput.style'

export type EmailInputProps = Pick<InputProps, 'value' | 'error' | 'onChange'> & {
    label?: string
    caption?: string
}

export const EmailInput: FC<EmailInputProps> = ({ value, error, onChange, label, caption }) => {
    return (
        <FormControl label={label} caption={caption} overrides={FormControlOverrides}>
            <Input type="email" placeholder={'E-Mail Adresse'} value={value} error={error} onChange={onChange} />
        </FormControl>
    )
}
